import {IS_CHINA} from "../utils/Environment";
import GoogleSearch from "@openmind/storelocator/src/core/search-engines/google/googlesearch";
import BaiduSearch from "@openmind/storelocator/src/core/search-engines/baidu/baidusearch";
import {BaiduMap} from "@openmind/storelocator/src/core/map-engines/baidu/baidumap";
import {GoogleMap} from "@openmind/storelocator/src/core/map-engines/google/googlemap";

export const getSearchEngine=()=>{
  return IS_CHINA?
  {
    EngineName:'BaiduSearch',
    Engine:BaiduSearch
  }:
  {
    EngineName:'GoogleSearch',
    Engine:GoogleSearch
  }
}

export const getMapEngine=()=>{
  return IS_CHINA?
  {
    EngineName:'BaiduMap',
    Engine:BaiduMap
  }:
  {
    EngineName:'GoogleMap',
    Engine:GoogleMap
  }
}

const searchEngineStaticRef=getSearchEngine().Engine;
const mapEngineStaticRef=getMapEngine().Engine;

export const simpleGeocoding=(coordinates,resolve)=>{
  searchEngineStaticRef.plainGeocode({coordinates,resolve});
}

export const viewportFromBoundAndPoint=(coordinates,points)=>{
  return mapEngineStaticRef.viewportFromBoundAndPoint(coordinates,points);
}

export const includePinsIfInBound=(coordinates,points)=>{
  return mapEngineStaticRef.includePinsIfInBound(coordinates,points);
}

export const applyEventOnAutocompleteChangePlace=(autocompleteComponent,callback)=>{
  return searchEngineStaticRef.applyEventOnAutocompleteChangePlace(autocompleteComponent,callback);
}

export const applyEventOnAutocomplete=(autocompleteComponent,event,callback)=>{
  return searchEngineStaticRef.applyEventOnAutocomplete(autocompleteComponent,event,callback);
}

export const applyRestrictionsOnAutocomplete=(autocompleteComponent,opt)=>{
  return searchEngineStaticRef.applyRestrictionsOnAutocomplete(autocompleteComponent,opt);
}
